import config from '@/assets/config.json';
import api from '../../api/index';
const state = {}
const mutations = {

}
const getters = {

}
const actions = {
    getQuickPriceDetail({
        rootState,
        commit
    }, opt) { //快速预警-列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/quick/report/product/price/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getQuickPriceList({
        rootState,
        commit
    }, opt) { //快速预警-列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/quick/report/product/price`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    deleteQuick({
        rootState,
        commit
    }, opt) { //快速预警-编辑
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/quick/delete`, {
                data: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    editQuick({
        rootState,
        commit
    }, opt) { //快速预警-编辑
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/quick/edit`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    createQuick({
        rootState,
        commit
    }, opt) { //快速预警-添加
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/quick/create`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    getQuickList({
        rootState,
        commit
    }, opt) { //快速预警-列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/quick/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getWarehouseList({ //地址列表获取
        rootState,
        commit
    }, opt) { //仓库地址管理-列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/Adm_Address/GetList`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
            // api.get(`${config.brandHttps.api}/merchant/warehouse/address/list`, {
            //     params: opt
            // }).then(data => {
            //     if (data) {
            //         resolve(data);
            //     }
            // }).catch((err) => {
            //     console.log(err);
            // });
        });
    },

    createWarehouse({
        rootState,
        commit
    }, opt) { //仓库地址管理-添加
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/warehouse/address/create`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    editWarehouse({
        rootState,
        commit
    }, opt) { //仓库地址管理-编辑
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/warehouse/address/update`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    warehouseDetail({
        rootState,
        commit
    }, opt) { //仓库地址管理-列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/warehouse/address/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    deleteWarehouse({
        rootState,
        commit
    }, opt) { //仓库地址管理-删除
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/warehouse/address/delete`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getProductPriceDetail({
        rootState,
        commit
    }, opt) { //经销商管理-价格上限详情
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/product/price/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    getProductPrice({
        rootState,
        commit
    }, opt) { //经销商管理-价格上限列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/product/price`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getFakeBrandDetail({
        rootState,
        commit
    }, opt) { //经销商管理-仿冒品牌详情
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/product/counterfeit/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getFakeBrand({
        rootState,
        commit
    }, opt) { //经销商管理-仿冒品牌列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/product/counterfeit`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getSellDetail({
        rootState,
        commit
    }, opt) { //违规监控-违规销售详情
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/illegal/sell/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getSellList({
        rootState,
        commit
    }, opt) { //违规监控-违规销售列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/illegal/sell`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getIllegalDetail({
        rootState,
        commit
    }, opt) { //违规监控-串货详情
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/illegal/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getIllegalArea({
        rootState,
        commit
    }, opt) { //违规监控-违规串货列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/illegal/area`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getReporCompeteProductchart({
        rootState,
        commit
    }, opt) { //竞品预警-折线图数据
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/report/compete/productchart`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getReporCompeteProduct({
        rootState,
        commit
    }, opt) { //竞品预警-列表接口
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/compete/product`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getunread({
        rootState,
        commit
    }, opt) { //违规监控模块的未读统计
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/public/unread`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    Agree({
        rootState,
        commit
    }, opt) { //退款-同意退款
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/refund/agree`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    Refuse({
        rootState,
        commit
    }, opt) { //退款-拒绝退款
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/refund/refund`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getRefundList({
        rootState,
        commit
    }, opt) { //退款-订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.shopHttps.api}/apimerchant/refund/list`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    deleteProductPlatform({
        rootState,
        commit
    }, opt) { //竞品列表-监控平台-编辑接口
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/compete/productplatform/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    editProductPlatform({
        rootState,
        commit
    }, opt) { //竞品列表-监控平台-编辑接口
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/compete/productplatform/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    createProductPlatform({
        rootState,
        commit
    }, opt) { //竞品列表-监控平台-添加接口
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/compete/productplatform`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getProductPlatform({
        rootState,
        commit
    }, opt) { //竞品列表-监控平台-列表接口
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/compete/productplatform`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getPlatform({
        rootState,
        commit
    }, opt) { //平台-列表接口
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/platform`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    editCompeteProduct({
        rootState,
        commit
    }, opt) { //竞品列表-编辑接口
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/compete/product/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    detailReportCompeteProduct({
        rootState,
        commit
    }, opt) { //竞品预警-详情接口
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/compete/product/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    detailCompeteProduct({
        rootState,
        commit
    }, opt) { //竞品列表-详情接口
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/compete/product/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    deleteCompeteProduct({
        rootState,
        commit
    }, opt) { //竞品列表-删除接口
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/compete/product/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    updateStatusCompeteProduct({
        rootState,
        commit
    }, opt) { // 竞品列表-更新状态
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/compete/product/updatestatus/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    createCompeteProduct({
        rootState,
        commit
    }, opt) { // 竞品列表-添加商品-添加
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/compete/product`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    competeProduct({
        rootState,
        commit
    }, opt) { //竞品列表-列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/compete/product`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    deleteCompeteBrand({
        rootState,
        commit
    }, opt) { // 竞品列表-品牌-删除
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/compete/brand/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    editCompeteBrand({
        rootState,
        commit
    }, opt) { // 竞品列表-品牌-编辑
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/compete/brand/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    createCompeteBrand({
        rootState,
        commit
    }, opt) { //竞品列表-品牌-添加
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/compete/brand`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    competeBrand({
        rootState,
        commit
    }, opt) { //竞品列表-品牌-列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/compete/brand`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    createAgency({
        rootState,
        commit
    }, opt) { //经销商-店铺导入
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/create`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    importShop({
        rootState,
        commit
    }, opt) { //经销商-店铺导入
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/shop/import`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    getAgencyProductList({
        rootState,
        commit
    }, opt) { //产品管理-列表
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agencyproduct/list`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getAgencyProductDetail({
        rootState,
        commit
    }, opt) { //产品管理-详情
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agencyproduct/detail`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    reopened({
        rootState,
        commit
    }, opt) { //产品管理-解封
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agencyproduct/reopened`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    forbidsale({
        rootState,
        commit
    }, opt) { //产品管理-禁售
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agencyproduct/forbidsale`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getCategoryList({
        rootState,
        commit
    }, opt) { //产品管理-分类列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/product/category?${opt}`).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getTreeList({
        rootState,
        commit
    }, opt) { //产品管理-树列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/product/categorychild`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // deleteCategory({
    //     rootState,
    //     commit
    // }, opt) { //产品管理-删除分类
    //     return new Promise((resolve, reject) => {
    //         api.delete(`${config.brandHttps.api}/merchant/product/category/${opt.id}`).then(data => {
    //             if (data) {
    //                 resolve(data);
    //             }
    //         }).catch((err) => {
    //             console.log(err);
    //         });
    //     });
    // },
    createCategory({
        rootState,
        commit
    }, opt) { //产品管理-添加分类
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/product/category`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    deleteCategory({
        rootState,
        commit
    }, opt) { //产品管理-类列表删除
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/product/category/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    editCategory({
        rootState,
        commit
    }, opt) { //产品管理-类列表删除
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/product/category/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getBrandList({
        rootState,
        commit
    }, opt) { //产品管理-品牌产权管理-列表
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/brand`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    addBrand({
        rootState,
        commit
    }, opt) { //产品管理-品牌产权管理-添加
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/brand`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    deleteBrand({
        rootState,
        commit
    }, opt) { //产品管理-品牌产权管理-删除
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/brand/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    updateStatusBrand({
        rootState,
        commit
    }, opt) { //产品管理-品牌产权管理-状态修改
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/brand/updatestatus/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getBrandDetail({
        rootState,
        commit
    }, opt) { //产品管理-品牌产权管理-详情
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/brand/${opt.id}?token=${opt.token}`).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    updateBrand({
        rootState,
        commit
    }, opt) { //产品管理-品牌产权管理-修改
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/brand/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商管理 - 列表
     */
    getAgencyList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/agency/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商管理 - 停权
     */
    stopAuthor({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/stopauthor`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商管理 - 解除停权
     */
    deAuthorize({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/deauthorize`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 经销商管理 - 分类列表
     */
    getDeauthorizeTypeList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/agency/deauthorizetypelist`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商管理 - 商品分类
     */
    getGoodsClassifys({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/goodsclassifys/childlist`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商管理 - 导入模板
     */
    upLoadTemplate({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/uploadtemplate`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商管理 - 下载模板
     */
    getTemplateUrl({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/agency/downloadtemplate`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 经销商管理 - 所属上级
     */
    getParentList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/agency/getparentlist`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商管理 - 产品监控删除
     */
    delAgencyProduct({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agencyproduct/delete`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 经销商管理 - 产品监控名单操作（黑白名单）
     */
    agencyProductUpdateType({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/agencyproduct/updatetype/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  经销商管理-模板列表
     */
    getTemplateList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/import/template`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  经销商管理-模板下载
     */
    downTemplate({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/import/export`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  经销商管理-商家后台-商品类目-品牌名称列表
     */
    getBrandName({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/brand/name`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  经销商管理-添加产品
     */
    createProduct({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/product/create`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  违规监控-敏感词列表
     */
    getSensitiveWordList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/sensitive/word`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  违规监控-敏感词详情
     */
    getSensitiveWordDetail({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/sensitive/word/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    /**
     * 授权监控-列表
     */
    getAuthorizationList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/authorization`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 授权监控-详情
     */
    getAuthorizationDetail({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/report/authorization/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 授权监控-历史记录
     */
    // getAuthorizationDetail({
    //     rootState,
    //     commit
    // }, opt) {
    //     return new Promise((resolve, reject) => {
    //         api.get(`${config.brandHttps.api}/merchant/report/authorization/${opt.id}`, {
    //             params: opt
    //         }).then(data => {
    //             if (data) {
    //                 resolve(data);
    //             }
    //         }).catch((err) => {
    //             console.log(err);
    //         });
    //     });
    // },

    /**
     * 经销商自定义规格--规格列表
     */
    getSpecList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/spec/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 经销商  表格导入-历史记录
     */
    getRecordList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/import/record/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 经销商  表格导入-历史记录删除
     */
    deleteRecord({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/import/record/del`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商  历史表格导入
     */
    productImport({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/product/import`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     * 经销商  取消
     */
    agencyChannel({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/channel`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 经销商 产品编辑
     */
    editAgencyProduct({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/product/edit`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     * 经销商 产品详情
     */
    agencyProductDetail({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/agency/product/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    agencyDetail({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/agency/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    editAgency({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/agency/edit`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}